import aiAssistantQueries from './ai-assistant';
import { authorizationQueries } from './authorization';
import bookmarkQueries from './bookmark';
import { boundingBoxQueries } from './bounding-boxes';
import breakQueries from './break';
import { cannedFieldQueries } from './canned-fields';
import { checkboxQueries } from './checkbox';
import commentQueries from './comments';
import dimensionsQueries from './dimensions';
import { documentQueries } from './document';
import { drawingQueries } from './drawing';
import { dynamicBlockQueries } from './dynamic-block';
import { fieldQueries } from './fields';
import formatQueries from './formats';
import generalQueries from './general';
import { headersAndFootersQueries } from './headers-and-footers';
import { imageQueries } from './image';
import inlineQueries from './inlines';
import leafQueries from './leaf';
import linkQueries from './links';
import listQueries from './list';
import locationQueries from './location';
import markerQueries from './marker';
import nodeQueries from './node';
import { paragraphQueries } from './paragraph';
import renderModelQueries from './render-model';
import searchQueries from './search';
import { selectionQueries } from './selection';
import stylesQueries from './styles';
import suggestionMarkerQueries from './suggestion-marker';
import { suggestionWithSourceQueries } from './suggestion-with-source';
import { tableQueries } from './table';
import { tableGridQueries } from './table-grid';
import trackedChangesQueries from './tracked-changes';

export const Queries = {
  ...aiAssistantQueries,
  ...authorizationQueries,
  ...breakQueries,
  ...bookmarkQueries,
  ...boundingBoxQueries,
  ...cannedFieldQueries,
  ...checkboxQueries,
  ...commentQueries,
  ...dimensionsQueries,
  ...documentQueries,
  ...drawingQueries,
  ...dynamicBlockQueries,
  ...fieldQueries,
  ...formatQueries,
  ...generalQueries,
  ...headersAndFootersQueries,
  ...imageQueries,
  ...inlineQueries,
  ...leafQueries,
  ...linkQueries,
  ...listQueries,
  ...locationQueries,
  ...markerQueries,
  ...nodeQueries,
  ...paragraphQueries,
  ...renderModelQueries,
  ...searchQueries,
  ...selectionQueries,
  ...stylesQueries,
  ...suggestionMarkerQueries,
  ...suggestionWithSourceQueries,
  ...tableQueries,
  ...tableGridQueries,
  ...trackedChangesQueries,
};
